<template>
  <div>
    <header-component class="header-component"></header-component>
    <div  class="main-content-component">
      <slot name="content"></slot>
    </div>
    <footer-component class="footer-component"></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "../components/Header"
import FooterComponent from "../components/Footer"
export default {
  name: "Layout",
  props: {},
  components: {
    HeaderComponent,
    FooterComponent
  }
}
</script>

<style scoped lang="scss">
  .main-content-component {
    min-height: calc(100vh - 71px - 111px);

    @media all and (min-width: 600px){
      min-height: calc(100vh - 45px - 69px);
    }
  }
</style>
